export const duiMaskConfig = {
  mask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/],
};

export const phoneNumberMaskConfig = {
  mask: [/\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/],
};

export const nitMaskConfig = {
  mask: [
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
  ],
};

export const passportMaskConfig = {
  mask: /^[A-Za-z][A-Za-z0-9]*$/,
};

export const carneMaskConfig = {
  mask: /^[A-Za-z][A-Za-z0-9]*$/,
};
